import React from 'react';
import PropTypes from 'prop-types';
import {
	addDays,
	format,
	isAfter,
	isSameDay,
	isSameMonth,
} from 'date-fns';
import CalendarDay from './CalendarDay';

function isClosed(date, closures) {
	return closures.some((closure) => isSameDay(date, closure));
}

function CalendarWeek({
	start,
	resWindow,
	closures,
	onDateClick,
	currentMonth,
	selectedDate,
	allValid,
	today,
}) {
	// Build days array
	const days = Array.from({ length: 7 }, (_, i) => {
		const date = addDays(start, i);
		const closed = isClosed(date, closures);
		const past =
			!isSameDay(date, today) && isAfter(today, date);
		const valid =
			!resWindow ||
			(!closed && !past && isAfter(resWindow, date));
		const isToday = isSameDay(date, today);
		const isSelected = selectedDate && isSameDay(date, selectedDate);

		return {
			date,
			closed: !allValid && !past && closed,
			today: isToday,
			past,
			open:
				!!allValid ||
				(isToday && valid) ||
				(!closed && !past && valid),
			invalid: !valid,
			notInCurrentMonth: !isSameMonth(currentMonth, date),
			selected: isSelected,
		};
	});

	return (
		<tr className="calendar-week">
			{days.map((day) => (
				<CalendarDay
					key={format(day.date, 'yyMMdd')}
					onDateClick={onDateClick}
					{...day}
				/>
			))}
		</tr>
	);
}

CalendarWeek.propTypes = {
	start: PropTypes.instanceOf(Date).isRequired,
	resWindow: PropTypes.instanceOf(Date),
	closures: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
	onDateClick: PropTypes.func,
	currentMonth: PropTypes.instanceOf(Date).isRequired,
	selectedDate: PropTypes.instanceOf(Date),
	allValid: PropTypes.bool,
	today: PropTypes.instanceOf(Date),
};

CalendarWeek.defaultProps = {
	closures: [],
	today: new Date(),
	allValid: false,
};

export default CalendarWeek;
